var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpikeTl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 398,
    height: 440,
    viewBox: "0 0 398 440",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.8945 -7.06445L136.915 369.749L75.7359 -7.45317",
    stroke: "url(#paint0_radial_16640_54385)",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-43.3086 -90.6816L-239.285 137.208L-28.1357 -61.5734",
    stroke: "url(#paint1_radial_16640_54385)",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M102.426 -13.3672L299.063 213.953L133.447 -24.1006",
    stroke: "url(#paint2_radial_16640_54385)",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M-1.08594 -39.0645L-65.4361 130.036L24.9774 -19.1093",
    stroke: "url(#paint3_radial_16640_54385)",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M159.277 -40.8516L303.25 68.7281L185.793 -60.2013",
    stroke: "url(#paint4_radial_16640_54385)",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_16640_54385",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(94.7158 181.346) rotate(76.7219) scale(167.159 1157.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.247309,
    stopColor: "#D7DF23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555008,
    stopColor: "#72BF44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#028144"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_16640_54385",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-141.422 23.0225) rotate(129.463) scale(130.954 1567.43)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.247309,
    stopColor: "#D7DF23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555008,
    stopColor: "#72BF44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#028144"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_16640_54385",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(200.488 100.382) rotate(47.908) scale(130.954 1567.43)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.247309,
    stopColor: "#D7DF23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555008,
    stopColor: "#72BF44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#028144"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_16640_54385",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-33.361 45.4092) rotate(109.852) scale(78.5477 752.763)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.247309,
    stopColor: "#D7DF23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555008,
    stopColor: "#72BF44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#028144"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_16640_54385",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(231.162 14.0125) rotate(36.2928) scale(78.5477 752.763)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.247309,
    stopColor: "#D7DF23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555008,
    stopColor: "#72BF44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#028144"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpikeTl);
export default __webpack_public_path__ + "static/media/spikeTL.6f205e2d96071837a4fc644a8275830f.svg";
export { ForwardRef as ReactComponent };